import types from '../types';

/**
 * @param {types.AdvancedFilter[]} filters
 * @param {string} filterId
 * @param {string} value
 * @returns {types.AdvancedFilter[]}
 */

const setAdvancedFiltersState = (filters, filterId, value) => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return [];
    }

    return filters.map(filter => {
        if (filter.id === filterId) {
            return {
                ...filter,
                value
            };
        }

        return filter;
    });
};

export default setAdvancedFiltersState;
